<template>
    <div>
        <input
                type="text"
                style="padding-left: 22px; margin-top: 7px; margin-bottom: 6px"
                :value="modelValue"
                @input="$emit('input', $event.target.value)"
                @keyup="keyUp"
                @keyup.enter="keyUpEnter"
                class="form-control"
            />
    </div>
</template>
<script>
import FiltroMixin from './FiltroMixin.js'
export default {
	mixins: [FiltroMixin],
	methods: {
		keyUp() {
			this.$emit('keyup')
		},
		keyUpEnter() {
			this.$emit('keyupenter')
		}
	},
}
</script>